import { FunctionComponent, useEffect, useState } from "react";
import Modal from "./Modal";
import Button from "../Button";
import { buttonTypes, userTypes } from "src/utils/types";
import { useAuth } from "src/context/AuthContext";
import { dynamo, sendgrid } from "src/utils";
import { TextInputWithRegister } from "src/components/inputs";
import { useForm } from "react-hook-form";
import { ToastStatus, useToast } from "src/context/ToastContext";

interface IInviteMemberModalProps {
  open: boolean;
  toggleModal: () => void;
}

const InviteMemberModal: FunctionComponent<IInviteMemberModalProps> = ({
  open,
  toggleModal,
}) => {
  const { setToast } = useToast();
  const { user } = useAuth();
  const { register, handleSubmit } = useForm({
    defaultValues: {
      email: "",
      name: "",
    },
  });

  const save = async (values: any) => {
    if (!user) return;
    try {
      const { name, email } = values;

      const sender = user.userType === userTypes.AccountTypes.REFERRAL ? user.userInfo.companyName : user.userInfo?.name

      const result = await sendgrid.sendInviteMember(name, email, user?.userId, sender);

      if (result.status === 202) {
        setToast({
          message: "Invitation Email Sent",
          status: ToastStatus.FAIL,
        });

        toggleModal();
      }
    } catch (error: any) {
      setToast({
        message: error?.message || "Member Invitation Failed",
        status: ToastStatus.FAIL,
      });
    }
  };

  return (
    <>
      <Button text="Invite Member" onClick={toggleModal} />
      <Modal
        open={open}
        title="Invite Member"
        content={
          <div>
            <TextInputWithRegister
              id="email"
              placeholder="Enter member's email..."
              register={register("email")}
            />

            <TextInputWithRegister
              id="name"
              placeholder="Enter member's name..."
              register={register("name")}
            />

            <div className="flex justify-evenly">
              <Button
                text="Cancel"
                theme={buttonTypes.BUTTON_THEME_TYPES.PRIMARY_INVERSE}
                onClick={toggleModal}
                styles="mr-4"
              />
              <Button text="Send" onClick={handleSubmit(save)} />
            </div>
          </div>
        }
        onClose={toggleModal}
      />
    </>
  );
};

export default InviteMemberModal;
